import { render, staticRenderFns } from "./penangonhand.vue?vue&type=template&id=38149c05&scoped=true&"
import script from "./penangonhand.vue?vue&type=script&lang=js&"
export * from "./penangonhand.vue?vue&type=script&lang=js&"
import style0 from "./penangonhand.vue?vue&type=style&index=0&id=38149c05&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38149c05",
  null
  
)

export default component.exports